import { List, styled } from '@mui/material';
import Link from 'next/link';

export const ListStyled = styled(List)(() => ({}));
export const LinkStyled = styled(Link)(() => ({}));
